import React from 'react';
import ColorVariant from './ColorVariant/ColorVariant';
import './VariantPicker.css';

function VariantPicker({product, variants, variant, title, onVariantClick}) {
    const handleVariantClick = (id) => {
        if (onVariantClick) onVariantClick(id);
    };

    const renderVariants = () => {
        if (!variants || variants.length === 0) return undefined;
        return variants.map((_variant) => {
            const selected = _variant.id === variant;
            return <ColorVariant key={`color-variant=${product.id}-${_variant.id}`} variant={_variant} selected={selected} onClick={handleVariantClick}/>;
        });
    };

    if (!variants || variants.length <= 1) return undefined;

    return (
        <div className='variant-picker'>
            <div className='variant-picker_title'>{title}</div>
            <div className='variant-picker_list'>
                {renderVariants()}
            </div>
        </div>
    );
}

export default VariantPicker;